var _ellipse, _ellipse2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 48,
  viewBox: "0 0 52 48",
  fill: "none"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 6,
  cy: 7.99099,
  rx: 6,
  ry: 5.99343,
  fill: "#BCDD64"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 46,
  cy: 7.99099,
  rx: 6,
  ry: 5.99343,
  fill: "#BCDD64"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 12.1615,
  height: 31.9737,
  rx: 6.08076,
  transform: "matrix(0.865631 -0.500683 0.499317 0.866419 17.5566 6.08905)",
  fill: "#BCDD64"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 12.1615,
  height: 31.9737,
  rx: 6.08076,
  transform: "matrix(0.865631 -0.500683 0.499317 0.866419 6.07715 20.2974)",
  fill: "#BCDD64"
})));
export default SvgLogo;